import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { PasswordService } from '@renovationman/rm-uaa-api-client-ts-ng20';
import { map } from 'rxjs/operators';

import {
  FIRST_LOGIN_QUERY_PARAM_KEY,
  RESET_CODE_QUERY_PARAM_KEY,
} from '~constants';

@Injectable({ providedIn: 'root' })
export class ResetCodeIsValidGuard {
  constructor(
    private passwordService: PasswordService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    if (!route.queryParamMap.has(RESET_CODE_QUERY_PARAM_KEY)) {
      return this.goToExpiredLinkPage(route);
    }
    return this.passwordService
      .isTokenValid(route.queryParamMap.get(RESET_CODE_QUERY_PARAM_KEY))
      .pipe(
        map((isValid) => {
          if (isValid && isValid[0]?.valid) {
            return true;
          }
          return this.goToExpiredLinkPage(route);
        })
      );
  }

  goToExpiredLinkPage(route: ActivatedRouteSnapshot) {
    return this.router.createUrlTree(['expired-link'], {
      queryParams: {
        [RESET_CODE_QUERY_PARAM_KEY]: undefined,
        [FIRST_LOGIN_QUERY_PARAM_KEY]: route.data.firstLogin,
      },
      queryParamsHandling: 'merge',
    });
  }
}
